import { render, staticRenderFns } from "./PaymentAccountConnected.vue?vue&type=template&id=bc1a5214"
import script from "./PaymentAccountConnected.vue?vue&type=script&lang=js"
export * from "./PaymentAccountConnected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports